import { alpha, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../constants/colors/Colors';

export const useStyles  = makeStyles((theme) => ({ 
    serviceContainer: {
        minHeight: 800,
        borderRadius: 12,
        backgroundColor: '#ffffff'
    },
    table: {
        minWidth: 650,
        [theme.breakpoints.down('sm')]: {
            width: 1500
        }
    },
    tableText: {
        display: 'flex',
        margin: 0,
        alignItems: 'center'
    },
    insideText: {
        marginLeft: 9,
        textAlign: 'left'
    },

    innerText: {
        display: 'flex',
        alignItems: 'center',
    },
    textTop: {
        margin: 0,
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: 16,
        fontFamily: 'Roboto-SemiBold'
    },
    text: {
        margin: 0,
        color: '#5B6773',
        fontfamily: 'Roboto-Regular',
    },
    dot: {
        width: 10,
        height: 10,
        borderRadius: 50,
        marginLeft: 5,
        marginRight: 5,
        backgroundColor: colors.primary
    },
    cloudDiv: {
        margin: 0,
    },
    cloudTextOne: {
        margin: 0,
        fontSize: 16,
        fontWeight: '600',
        fontStyle: 'normal',
        color: '#091E42',
        fontFamily: 'Roboto-SemiBold'
    },
    cloudTextTwo: {
        margin: 0,
        fontSize: 14,
        fontWeight: '400',
        fontStyle: 'normal',
        color: '#5B6773'
    },
    serviceText: {
        margin: 0,
        fontWeight: '500',
        fontSize: 30,
        color: '#091E42',
        fontFamily: 'Roboto-Medium'
    },
    toolbarContainer: {
        justifyContent: 'space-between',
        display: 'flex',
        marginBottom: 15,
        [theme.breakpoints.down('sm')]: {
            display: 'block',
            justifyContent: 'flex-start',
            marginBottom: 0,
        },
    },
    searchContainer: {
        backgroundColor: '#fff',
        width: '60%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: 8,
        border: '1px solid #D4DDE4',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginBottom: 20
        }
    },
    icon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    input: {
        borderRadius: 8,
        border: 'none',
        width: '99%',
        padding: '14px',
        outline: 'none',
        fontFamily: 'Roboto-SemiBold',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: 16,
        color: '#94999E',
    },
    tabelHeadText: {
    },
    button: {
        background: 'linear-gradient(90deg, #824ED2 -0.14%, #B07DFF 99.93%)',
        [theme.breakpoints.down('sm')]: {
            marginBottom: 20
        }
    },
    commonPlaceholder: {
        paddingLeft: 15,
        position: 'absolute',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: '400',
        fontSize: 16,
        color: '#94999E',
    },
    boldPlaceHolder: {
        color: '#5B6773',
        fontWeight:  '600',
    },
    placeHolder: {
        display: 'none'
    }
}));

